import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import LogoPNG from "src/assets/icons/logo.png"
import { useLoginContext } from "src/hooks/useLoginContext"

import { AppBar, Box, Button, Image, Toolbar, Typography } from "src/UILibrary"

import { useMediaQuery } from "react-responsive"
import MenuIcon from "src/assets/icons/menu.svg"
import { OutlinedButton } from "../buttons/OutlinedButton"
import "./header.scss"

const Header = () => {
  const { t } = useTranslation("translation", { keyPrefix: "header" })

  const isPC = useMediaQuery({ query: "(min-width: 1300px)" })
  const isMd = useMediaQuery({ query: "(min-width: 500px)" })

  const navigate = useNavigate()

  const path = useLocation()

  const { loggedin, logout } = useLoginContext()

  const [showMenu, setShowMenu] = useState<boolean>(false)

  const handleDataDownload = () => {
    const element = document.getElementById("download")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    } else {
      navigate("/#download")
    }
  }

  useEffect(() => {
    setShowMenu(false)
  }, [path])

  return (
    <AppBar
      position="static"
      sx={{
        color: "text.primary",
        boxShadow: "none",
        maxWidth: "100%",
        mx: "auto",
        bgcolor: "white",
      }}
    >
      <Box width="100%" className="header-title-background">
        <Typography.SubTitle
          sx={{
            fontWeight: "700",
            fontFamily: "Noto Sans JP !important",
            mx: "auto",
            color: "white",
            lineHeight: "1rem",
          }}
        >
          {t("description")}
        </Typography.SubTitle>
      </Box>
      <Toolbar className="toolbar">
        {isPC ? (
          <>
            <Image
              src={LogoPNG}
              imageStyle={{ width: "100%", height: "100%" }}
              sx={{ height: "80px", mr: "auto", cursor: "pointer" }}
              onClick={() => navigate("/")}
            />
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={() => navigate("/event")}
              >
                {t("event_book")}
              </Typography.SubTitle>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={() => navigate("/adviser")}
              >
                {t("adviser_book")}
              </Typography.SubTitle>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={() => navigate("/service_introduction")}
              >
                {t("company_service_list")}
              </Typography.SubTitle>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={() => navigate("/job_offer")}
              >
                {t("job_list")}
              </Typography.SubTitle>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={() => navigate("/news")}
              >
                {t("news_list")}
              </Typography.SubTitle>
              <Typography.SubTitle
                sx={{
                  fontWeight: 700,
                  p: "0.375rem 1.25rem",
                  fontFamily: "Noto Sans JP !important",
                  "&:hover": { cursor: "pointer" },
                }}
                onClick={handleDataDownload}
              >
                {t("data_download")}
              </Typography.SubTitle>
              {loggedin ? (
                <>
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: "160px",
                      py: "10px",
                      fontSize: "1rem",
                      fontFamily: "Noto Sans JP !important",
                      lineHeight: "1rem",
                      borderRadius: "0px",
                      ":hover": {
                        bgcolor: "#2DA389",
                      },
                    }}
                    onClick={() => navigate("/mypage")}
                  >
                    {t("my_page")}
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: "160px",
                      py: "10px",
                      fontSize: "1rem",
                      fontFamily: "Noto Sans JP !important",
                      lineHeight: "1rem",
                      borderRadius: "0px",
                      ":hover": {
                        bgcolor: "#2DA389",
                      },
                    }}
                    onClick={() => {
                      logout()
                      navigate("/")
                    }}
                  >
                    {t("logout")}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: "160px",
                      py: "10px",
                      fontSize: "1rem",
                      fontFamily: "Noto Sans JP !important",
                      lineHeight: "1rem",
                      borderRadius: "0px",
                      ":hover": {
                        bgcolor: "#2DA389",
                      },
                    }}
                    onClick={() => navigate("/signup/type")}
                  >
                    {t("register")}
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: "160px",
                      py: "10px",
                      fontSize: "1rem",
                      fontFamily: "Noto Sans JP !important",
                      lineHeight: "1rem",
                      borderRadius: "0px",
                      ":hover": {
                        bgcolor: "#2DA389",
                      },
                    }}
                    onClick={() => navigate("/signin")}
                  >
                    {t("login")}
                  </Button>
                </>
              )}
            </Box>
          </>
        ) : (
          <>
            {isMd ? (
              <Box display="block" sx={{ width: "100%" }}>
                <Box display="flex" sx={{ width: "100%" }}>
                  <Image
                    src={LogoPNG}
                    imageStyle={{ height: "100%", ml: "10px", mr: "auto" }}
                    sx={{ height: "50px", cursor: "pointer", display: "flex" }}
                    onClick={() => navigate("/")}
                  />
                  <Box display="flex" sx={{ ml: "auto" }}>
                    {loggedin ? (
                      <>
                        <OutlinedButton
                          sx={{
                            width: "125px",
                            fontFamily: "Noto Sans JP !important",
                            borderRadius: "0px",
                            border: "2px solid #1F6757",
                            height: "50px",
                          }}
                          caption={t("my_page")}
                          fontColor="#1F6757"
                          fontWeight="700"
                          fontSize={14}
                          onClick={() => navigate("/mypage")}
                        />
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{
                            width: "125px",
                            height: "50px",
                            fontSize: "14px",
                            fontFamily: "Noto Sans JP !important",
                            lineHeight: "1rem",
                            borderRadius: "0px",
                            ":hover": {
                              bgcolor: "#2DA389",
                            },
                          }}
                          onClick={() => {
                            logout()
                            navigate("/")
                          }}
                        >
                          {t("logout")}
                        </Button>
                      </>
                    ) : (
                      <>
                        <OutlinedButton
                          sx={{
                            width: "125px",
                            fontFamily: "Noto Sans JP !important",
                            borderRadius: "0px",
                            border: "2px solid #1F6757",
                            height: "50px",
                          }}
                          caption={t("register")}
                          fontColor="#1F6757"
                          fontWeight="700"
                          fontSize={14}
                          onClick={() => navigate("/signup/type")}
                        />
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{
                            width: "125px",
                            height: "50px",
                            fontSize: "14px",
                            fontFamily: "Noto Sans JP !important",
                            lineHeight: "1rem",
                            borderRadius: "0px",
                            ":hover": {
                              bgcolor: "#2DA389",
                            },
                          }}
                          onClick={() => navigate("/signin")}
                        >
                          {t("login")}
                        </Button>
                      </>
                    )}
                    <Box
                      sx={{ width: "125px", height: "50px", display: "flex" }}
                      onClick={() => setShowMenu(!showMenu)}
                    >
                      <Box display="flex" sx={{ mx: "auto", my: "auto" }}>
                        <Image
                          src={MenuIcon}
                          imageStyle={{ width: "100%", height: "100%" }}
                          sx={{ my: "auto", lineHeight: "16px" }}
                        />
                        <Typography.SubTitle
                          sx={{
                            ml: "10px",
                            my: "auto",
                            fontSize: "14px",
                            fontWeight: "700",
                            fontFamily: "Noto Sans JP !important",
                          }}
                        >
                          MENU
                        </Typography.SubTitle>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {!isMd && (
                  <Image
                    src={LogoPNG}
                    imageStyle={{ height: "100%", mx: "auto" }}
                    sx={{ height: "50px", cursor: "pointer", display: "flex" }}
                    onClick={() => navigate("/")}
                  />
                )}

                <Box width="100%" className="header-title-background-sp">
                  <Typography.SubTitle
                    sx={{
                      fontWeight: "700",
                      fontFamily: "Noto Sans JP !important",
                      mx: "auto",
                      color: "white",
                      lineHeight: "1rem",
                    }}
                  >
                    {t("description")}
                  </Typography.SubTitle>
                </Box>
                {showMenu && (
                  <Box
                    sx={{
                      width: "100%",
                      display: "block",
                      bgcolor: "white",
                      position: "absolute",
                      top: "50px",
                      zIndex: 2000,
                    }}
                  >
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/event")}
                    >
                      {t("event_book")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/adviser")}
                    >
                      {t("adviser_book")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/service_introduction")}
                    >
                      {t("company_service_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/job_offer")}
                    >
                      {t("job_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/news")}
                    >
                      {t("news_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={handleDataDownload}
                    >
                      {t("data_download")}
                    </Typography.SubTitle>
                  </Box>
                )}
              </Box>
            ) : (
              <Box display="block" sx={{ width: "100%" }}>
                <Box display="flex" sx={{ width: "100%" }}>
                  <Box display="flex" width="100%">
                    {loggedin ? (
                      <Box width="100%" display="flex">
                        <OutlinedButton
                          sx={{
                            width: "calc(100% / 3)",
                            fontFamily: "Noto Sans JP !important",
                            borderRadius: "0px",
                            border: "2px solid #1F6757",
                            height: "50px",
                          }}
                          caption={t("my_page")}
                          fontColor="#1F6757"
                          fontWeight="700"
                          fontSize={14}
                          onClick={() => navigate("/mypage")}
                        />
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{
                            width: "calc(100% / 3)",
                            height: "50px",
                            fontSize: "14px",
                            fontFamily: "Noto Sans JP !important",
                            lineHeight: "1rem",
                            borderRadius: "0px",
                            ":hover": {
                              bgcolor: "#2DA389",
                            },
                          }}
                          onClick={() => {
                            logout()
                            navigate("/")
                          }}
                        >
                          {t("logout")}
                        </Button>
                        <Box
                          sx={{ width: "calc(100% / 3)", height: "50px", display: "flex" }}
                          onClick={() => setShowMenu(!showMenu)}
                        >
                          <Box display="flex" sx={{ mx: "auto", my: "auto" }}>
                            <Image
                              src={MenuIcon}
                              imageStyle={{ width: "100%", height: "100%" }}
                              sx={{ my: "auto", lineHeight: "16px" }}
                            />
                            <Typography.SubTitle
                              sx={{
                                ml: "10px",
                                my: "auto",
                                fontSize: "14px",
                                fontWeight: "700",
                                fontFamily: "Noto Sans JP !important",
                              }}
                            >
                              MENU
                            </Typography.SubTitle>
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Box width="100%" display="flex">
                        <OutlinedButton
                          sx={{
                            width: "calc(100% / 3)",
                            fontFamily: "Noto Sans JP !important",
                            borderRadius: "0px",
                            border: "2px solid #1F6757",
                            height: "50px",
                          }}
                          caption={t("register")}
                          fontColor="#1F6757"
                          fontWeight="700"
                          fontSize={14}
                          onClick={() => navigate("/signup/type")}
                        />
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{
                            width: "calc(100% / 3)",
                            height: "50px",
                            fontSize: "14px",
                            fontFamily: "Noto Sans JP !important",
                            lineHeight: "1rem",
                            borderRadius: "0px",
                            ":hover": {
                              bgcolor: "#2DA389",
                            },
                          }}
                          onClick={() => navigate("/signin")}
                        >
                          {t("login")}
                        </Button>
                        <Box
                          sx={{ width: "calc(100% / 3)", height: "50px", display: "flex" }}
                          onClick={() => setShowMenu(!showMenu)}
                        >
                          <Box display="flex" sx={{ mx: "auto", my: "auto" }}>
                            <Image
                              src={MenuIcon}
                              imageStyle={{ width: "100%", height: "100%" }}
                              sx={{ my: "auto", lineHeight: "16px" }}
                            />
                            <Typography.SubTitle
                              sx={{
                                ml: "10px",
                                my: "auto",
                                fontSize: "14px",
                                fontWeight: "700",
                                fontFamily: "Noto Sans JP !important",
                              }}
                            >
                              MENU
                            </Typography.SubTitle>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Image
                  src={LogoPNG}
                  imageStyle={{ height: "100%", mx: "auto" }}
                  sx={{ height: "50px", cursor: "pointer", display: "flex" }}
                  onClick={() => navigate("/")}
                />
                <Box width="100%" className="header-title-background-sp">
                  <Typography.SubTitle
                    sx={{
                      fontWeight: "700",
                      fontFamily: "Noto Sans JP !important",
                      mx: "auto",
                      color: "white",
                      lineHeight: "1rem",
                    }}
                  >
                    {t("description")}
                  </Typography.SubTitle>
                </Box>
                {showMenu && (
                  <Box
                    sx={{
                      width: "100%",
                      display: "block",
                      bgcolor: "white",
                      position: "absolute",
                      top: "50px",
                      zIndex: 2000,
                    }}
                  >
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/event")}
                    >
                      {t("event_book")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/adviser")}
                    >
                      {t("adviser_book")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/service_introduction")}
                    >
                      {t("company_service_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/job_offer")}
                    >
                      {t("job_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={() => navigate("/news")}
                    >
                      {t("news_list")}
                    </Typography.SubTitle>
                    <Typography.SubTitle
                      sx={{
                        fontWeight: 700,
                        py: "16px",
                        fontFamily: "Noto Sans JP !important",
                        "&:hover": { cursor: "pointer" },
                        textAlign: "center",
                      }}
                      onClick={handleDataDownload}
                    >
                      {t("data_download")}
                    </Typography.SubTitle>
                  </Box>
                )}
              </Box>
            )}
          </>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Header
